import { render } from "./ArticleView.vue?vue&type=template&id=d9779f82&scoped=true"
import script from "./ArticleView.vue?vue&type=script&lang=js"
export * from "./ArticleView.vue?vue&type=script&lang=js"

import "./ArticleView.vue?vue&type=style&index=0&id=d9779f82&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d9779f82"

export default script